module.exports = __webpack_public_path__ + "static/img/3_2_3.c4cebb45.jpg";